import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ListaKlientow from './klienci/ListaKlientow';
import FormularzKlienta from './klienci/FormularzKlienta';
import FormularzEdycjaKlienta from './klienci/FormularzEdycjaKlienta';
import OknoEdycji from './klienci/OknoEdycji';
import "./componenetStyle/Klienci.css";
import { useAuth } from '../auth/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

function Klienci() {
  const { hasPermission, hasAnyPermission } = useAuth();
  const canCreateClient = hasPermission('clients_create');
  const canEditClient = hasAnyPermission(['clients_edit_all', 'clients_edit_own']);
  const canDeleteClient = hasAnyPermission(['clients_delete_all', 'clients_delete_own']);

    const [klienci, setKlienci] = useState([]);
    const [edytowanyKlient, setEdytowanyKlient] = useState(null);
    const [pokazFormularzEdycja, setPokazFormularzEdycja] = useState(false);
    const [komunikat, setKomunikat] = useState('');
    const [isOknoEdycjiOpen, setOknoEdycjiOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState('ASC');
    const [searchInput, setSearchInput] = useState('');  
    const [searchTerm, setSearchTerm] = useState('');  
    const [totalPages, setTotalPages] = useState(1);

    const handleSearch = () => {
    setPage(1);                      
    setSearchTerm(searchInput.trim());
    };

    const handleKlientAdded = (nowyKlient) => {
        setKlienci([...klienci, nowyKlient]);
        setOknoEdycjiOpen(false); 
    };

    const handleKlientEdited = (edytowanyKlient) => {
      const zaktualizowaniKlienci = klienci.map(klient =>
          klient.id_klient === edytowanyKlient.id_klient ? edytowanyKlient : klient
      );
      setKlienci(zaktualizowaniKlienci);
      setPokazFormularzEdycja(false);
    };

    const handleEdit = (id_klient) => {
      const klientDoEdycji = klienci.find(klient => klient.id_klient === id_klient);
      setEdytowanyKlient(klientDoEdycji);
      setPokazFormularzEdycja(true);
     };

     const handleDelete = async (id_klient) => {
      if (!canDeleteClient) return;
      const potwierdzenie = window.confirm("Czy na pewno chcesz usunąć tego klienta?");
      if (potwierdzenie) {
      try {
          const token = localStorage.getItem('token');
          await axios.delete(`${API_URL}/klienci/${id_klient}`, {
              headers: {
                  Authorization: `Bearer ${token}`
              }
          });
          setKlienci(klienci.filter(klient => klient.id_klient !== id_klient));
          setKomunikat('Klient usunięty.');
      } catch (error) {
        console.error('Błąd usuwania klienta:', error);
        setKomunikat(`Błąd: ${error.message}`);
      }
    } else {
        setKomunikat('Usuwanie anulowane.');
    }
      };


    const fetchKlienci = async () => {
    try {
      const token = localStorage.getItem('token');
      const resp = await axios.get(`${API_URL}/klienci`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search: searchTerm || undefined , sortField: sortField || undefined, sortOrder: sortOrder}
      });
      const { klienci: lista, totalPages } = resp.data;
      setKlienci(lista);
      setTotalPages(totalPages);
    } catch (err) {
      console.error('Błąd pobierania klientów:', err);
    }
  };

  useEffect(() => {
    fetchKlienci();
  }, [page, limit, searchTerm, sortField, sortOrder]);

  const handleSearchChange = e => {
    setSearchTerm(e.target.value);
    setPage(1);
  };

    return (
      <div>
          <h1>Klienci</h1>
          

            {canCreateClient
            ?<button onClick={() => setOknoEdycjiOpen(true)}>
              {isOknoEdycjiOpen ? 'Ukryj formularz' : 'Dodaj klienta'}
            </button>
            :<></>}

            <OknoEdycji isOpen={isOknoEdycjiOpen && canCreateClient} onClose={() => setOknoEdycjiOpen(false)}>
                <FormularzKlienta onKlientAdded={handleKlientAdded} />
            </OknoEdycji>
          <div className="pagination-controls">
          {/* 2️⃣ Wybór rozmiaru strony */}
            <div className="limit-controls">
              Pokaż na stronie:&nbsp;
              {[20, 50, 100].map(n => (
                <button
                  key={n}
                  onClick={() => { setLimit(n); setPage(1); }}
                  className={limit === n ? 'selected' : ''}
                >
                  {n}
                </button>
              ))}
            </div>

            {/* 3️⃣ Nawigacja stron */}
            <div className="pagination-arrows">
              <button
                className="pagination-arrow-button"
                onClick={() => page > 1 && setPage(page - 1)}
                disabled={page === 1}
              >
                ‹
              </button>
              <span> {page} / {totalPages} </span>
              <button 
                className="pagination-arrow-button"
                onClick={() => page < totalPages && setPage(page + 1)}
                disabled={page === totalPages}
              >
                ›
              </button>
            </div>
          </div>
          {/* 1️⃣ Wyszukiwanie uruchamiane przyciskiem */}
          <div style={{ margin: '1em 0' }}>
          <input
              type="text"
              placeholder="Szukaj klientów..."
              value={searchInput}
              onChange={e => setSearchInput(e.target.value)}
          />
          <button onClick={handleSearch}>Szukaj</button>
          </div>

            <ListaKlientow
                klienci={klienci}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={(field) => {
                    if (sortField === field) {
                    setSortOrder(o => o === 'ASC' ? 'DESC' : 'ASC');
                    } else {
                    setSortField(field);
                    setSortOrder('ASC');
                    }
                    setPage(1);  // zawsze wracamy do pierwszej strony
                }}
                onEdit={handleEdit}
                onDelete={handleDelete}
                refreshKlienci={fetchKlienci}
                canEdit={canEditClient}
                canDelete={canDeleteClient}
            />
              <OknoEdycji isOpen={pokazFormularzEdycja && canEditClient} onClose={() => setPokazFormularzEdycja(false)}>
                <FormularzEdycjaKlienta klient={edytowanyKlient} onKlientEdited={handleKlientEdited} />
            </OknoEdycji>
            {komunikat && <p>{komunikat}</p>}
      </div>
  );
}

export default Klienci;